export const checkIfStationPdfExists = async ({ stationId, parentStationId, isSummer }) => {
    const seasonText = isSummer ? 'summer' : 'winter';
    const stationPdfLink = `https://www.travelski.com/guide/document/Guide-${seasonText}_id_${stationId}.pdf`;

    try {
        const response = await fetch(stationPdfLink, { method: 'HEAD' });
        if (response.ok) {
            return stationPdfLink;
        }
    } catch (error) {
        // Station PDF not found, try parent if available
    }

    if (parentStationId) {
        const parentPdfLink = `https://www.travelski.com/guide/document/Guide-${seasonText}_id_${parentStationId}.pdf`;
        try {
            const response = await fetch(parentPdfLink, { method: 'HEAD' });
            if (response.ok) {
                return parentPdfLink;
            }
        } catch (error) {
            // Parent PDF not found
        }
    }

    return null;
}
